<template>
    <div class="inner-container">
        <div class="section-title budget"><i class="icon icon-calculator-coins"></i><span>Бюджет</span></div>
        <div class="section-subtitle"><i class="icon icon-grid"></i><span>{{ $t("app.links.budget_requests") }}<budget-forms-list :curFormSelect="'/form01-123'"/></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadDeltaRep="downloadDeltaRep"
                @downloadBatchReports="downloadBatchReports"
            ></forms-download-reprt>
        </div>
        <div class="filter-container">
            <div class="left-content">
            </div>
            <div class="right-content">
                <c-budget-forms-data-transfer
                    v-if="!isGkkpMode && !(progress < 100) && variantAttribute"
                    :header="header"
                    :lng="lng"
                    :getDataTransferText="getDataTransferText"
                    :getErrText="getErrText"
                    :makeToast="makeToast"
                    @reloadTable="loadDatas"
                />
                <div class="filter-actions filter-actions-flex">
                    <c-budget-forms-copy-data
                        v-if="!(progress < 100) && variantAttribute && (header.year < header.cur_year + 2)"
                        :budgetForm="budgetForm"
                        :header="header"
                        :isLoad="isLoad"
                        @keyPress="keyPress"
                    />
                    <b-button :style="{ 'minWidth': '110px' }" variant="success" @click="prepareForSave" :disabled="isLoad || !variantAttribute || load || !isDirty || budgetForm.length === 0">{{ getCommonText('save') }}</b-button>
                </div>
            </div>
        </div>

        <div class="table-container">
            <b-overlay :show="mainTableOverlay" rounded="sm">
            <b-table
                :fields="tableFields"
                :items="budgetForm"
                responsive="true"
                bordered
                head-variant="light"
                sticky-header="true"
                no-border-collapse
            >
                <template #top-row="data">
                    <td class="td-numbering"></td>
                    <td class="td-numbering table-success">1</td>
                    <td class="td-numbering table-danger">2</td>
                    <td class="td-numbering table-info">3</td>
                    <td class="td-numbering table-primary">4</td>
                    <td class="td-numbering table-warning">5</td>
                    <td class="td-numbering table-success">6</td>
                    <td class="td-numbering"></td>
                </template>
                <template #head(action)>
                    <div class="text-center">
                        <b-form-checkbox
                            v-model="selectAll"
                            @change="e => setIsAllDelete(e)"
                            :value="true"
                            :unchecked-value="false" />
                    </div>
                </template>
                <template #head(more)>
                    <div class="text-center">
                        <i
                            :title="getCommonText('del_selected')"
                            class="icon icon-close table-all-remove"
                            @click="deleteItem(`${selectAll ? getCommonText('clear_all') : getCommonText('clear')}`)"/>
                    </div>
                </template>
                <template #cell(action)="data">
                    <b-form-checkbox
                        v-model="data.item.itemToDelete"
                        @input="e => { if (!e) selectAll = false; }"
                        :value="true"
                        :unchecked-value="false" />
                </template>
                <template #cell(order_number)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell(expense_name)="data">
                    <div>{{ data.item.name }}</div>
                </template>
                <template #cell(expense_amount)="data">
                    <div :class="{ 'error': variantAttribute && (parseInt(data.item.candidate_count) > 0) && !(parseFloat(data.item.expense_amount) > 0) }">
                        <b-form-input v-if="variantAttribute"
                                      class="text-right"
                                      :value="data.item.expense_amount"
                                      @change="v => data.item.expense_amount = v"
                                      @keyup.enter.exact="keyup13"
                                      @keypress="keyPress($event, '^\\d*\\.?\\d{0,2}$')"
                                      @blur="inputFixedVldtn(data.item, 'expense_amount', data.item.expense_amount, 2)">
                        </b-form-input>
                        <div v-else class="text-right">{{ $n(data.value) }}</div>
                        <template v-if="variantAttribute && (parseInt(data.item.candidate_count) > 0) && !(parseFloat(data.item.expense_amount) > 0)">
                            <p class="goods-form-val-msg">{{ getCommonText('positive') }}</p>
                        </template>
                    </div>
                </template>
                <template #cell(candidate_count)="data">
                    <div :class="{ 'error': variantAttribute && (parseFloat(data.item.expense_amount) > 0) && !(parseInt(data.item.candidate_count) > 0) }">
                        <b-form-input v-if="variantAttribute"
                                      class="text-right"
                                      :value="data.item.candidate_count"
                                      @change="v => data.item.candidate_count = v"
                                      @keyup.enter.exact="keyup13"
                                      @keypress="keyPress($event, '^\\d+$')"
                                      @blur="inputFixedVldtn(data.item, 'candidate_count', data.item.candidate_count, 0)">
                        </b-form-input>
                        <div v-else class="text-right">{{ data.value }}</div>
                        <template v-if="variantAttribute && (parseFloat(data.item.expense_amount) > 0) && !(parseInt(data.item.candidate_count) > 0)">
                            <p class="goods-form-val-msg">{{ getCommonText('positive') }}</p>
                        </template>
                    </div>
                </template>
                <template #cell(total_expense)="data">
                    <div class="text-right">
                        {{ $n(data.item.total) }}
                    </div>
                </template>

                <template #cell(files)="data">
                    <span
                        class="blue pointer underline"
                        @click="onFilesClick(data.item)"
                    >({{data.item.files}})</span>
                </template>
                <template #cell(more)="data">
                    <div class="text-center">
                        <i
                            :title="getCommonText('clear_rec')"
                            class="icon icon-clear table-remove"
                            v-if="variantAttribute"
                            @click="deleteItem(`${getCommonText('clear_rec')}?`, data.item)"
                        ></i>
                    </div>
                </template>

                <template #bottom-row>
                    <td class="text-right" colspan="5">{{ getCommonText('total') }}</td>
                    <td class="text-right">{{ $n(total) }}</td>
                    <td colspan="2"></td>
                </template>
            </b-table>
            </b-overlay>
        </div>
        <files-updown v-if="isFilterReady"
                      :header="header"
                      :variant-attribute="variantAttribute"
                      :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
                      :load="load"
                      @getFiles="getFiles"
                      @getNewFiles="getNewFiles($event)"
                      @delFile="delFile($event)"
                      @onFilePreview="onFilePreview"
                      ref="fileUpdown"
        ></files-updown>
        <modal-files-management-nodecode
            ref="modalFilesManagement"
            :variant-attribute="variantAttribute"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
            @fileUpload="fileUpload"
            @toggleIsAdd="toggleIsAdd($event)"
            />
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import FilesUpdown from '@/modules/budget-request/FilesUpdown';
import BudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import ModalFilesManagementNodecode from './components/modal-files-management-nodecode.vue';
import CBudgetFormsCopyData from './components/budget-forms-copy-data.vue';
import FormsHandlerMixin1 from "./mixins/forms-handler-mixin-1";
import FormsDownloadReprt from "./components/forms-download-reprt.vue";
import CBudgetFormsDataTransfer from './components/budget-forms-data-transfer.vue';

export default {
    name: 'Form02-166',
    components: {
        FilesUpdown,
        BudgetFormsList,
        FormsDownloadReprt,
        ModalFilesManagementNodecode,
        CBudgetFormsCopyData,
        CBudgetFormsDataTransfer
    },
    mixins: [FormsHandlerMixin1],
    created() {
        this.$emit("setForm", this.form);
    },
    async mounted() {
        this.progress = 15;
    },
    watch: {
        openDisabled() {
            this.$emit("setOpenDisabled", this.openDisabled);
        },
        progress() {
            this.$emit("setProgress", this.progress);
        },
        budgetForm: {
            deep: true,
            handler() {
                this.isDirty = true;
            }
        }
    },
    data() {
        return {
            form: {
                code: '02-166',
                name_kk: '',
                name_ru: 'Расчет расходов на оплату выборов'
            },
            variantAttribute: null,
            variantName: null,
            budgetForm: [],
            header: null,
            files: null,
            load: true,
            openDisabled: false,
            dictElectionExpense: [],
            isLoad: false,
            isDirty: false,
            row_files: [],
            isAdd: false,
            rowId: false,
            newRowStartId: -1,
        };
    },
    methods: {
        defineTotal(item) {
            Object.defineProperty(item, 'total', {
                get: () => {
                    const expenseAmount = this.safeDecimal(item.expense_amount);
                    const candidateCount = this.safeDecimal(item.candidate_count);
                    return expenseAmount.mul(candidateCount).div(1000).toDecimalPlaces(2).toNumber();
                }
            });
        },

        resetRow(item) {
            this.$set(item, 'id', this.newRowStartId);
            this.newRowStartId--;
            this.$set(item, 'expense_amount', 0);
            this.$set(item, 'candidate_count', 0);
            this.$set(item, 'files', 0);
            this.$set(item, 'row_files', []);
            this.$set(item, 'itemToDelete', false);
        }, // сбрасывает значения строки справочника (сама строка остается в таблице)

        deleteItem(msg, row = false) {
            if (!this.variantAttribute || this.isLoad
                || (!row && this.budgetForm.findIndex(itm => itm.itemToDelete) === -1)) return;
            this.$bvModal.msgBoxConfirm(
                msg,
                {
                    title: this.getCommonText('confirm'),
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: this.getCommonText('yes'),
                    cancelTitle: this.getCommonText('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    if (!value) return;
                    if (row) {
                        if (row.id > 0) {
                            await this.deleteExpenseRows([row], [row.id]);
                        } else {
                            this.resetRow(row);
                        }
                    } else {
                        const rowsToDeleteFromDb = [];
                        const idsToDeleteFromDb = [];
                        this.budgetForm.forEach(item => {
                            if (item.itemToDelete) {
                                if (item.id > 0) {
                                    rowsToDeleteFromDb.push(item);
                                    idsToDeleteFromDb.push(item.id);
                                } else {
                                    this.resetRow(item);
                                }
                            }
                        });
                        if (rowsToDeleteFromDb.length) {
                            await this.deleteExpenseRows(rowsToDeleteFromDb, idsToDeleteFromDb);
                        } else {
                            this.selectAll = false;
                        }
                    }
                })
                .catch(error => {
                    this.makeToast('danger', this.getErrText('on_del'), error.toString());
                });
        }, // очищает значения строки/строк, сама строка справочника остается видимой

        async deleteExpenseRows(items, ids) {
            this.isLoad = true;
            const dataToDel = {
                items,
                form: this.form.code
            };
            try {
                this.calcTotal(ids);
                const response = await fetch('/api-py/delete-budget-request-multiple-rows-with-files/' + JSON.stringify(this.header), {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(dataToDel)
                });
                const result = await response.json();
                if ((response.status === 200) && (result.result === 'success')) {
                    items.forEach(item => this.resetRow(item));
                    this.selectAll = false;
                    this.makeToast('success', this.getErrText('msg'), items.length === 1 ? this.getErrText('one_deleted') : this.getErrText('deleted'));
                    this.deletingAgreementTotalResultHandler(result);
                } else {
                    this.makeToast('danger', this.getErrText('warning'), this.getErrText('on_del'));
                }
            } catch {
                this.makeToast('danger', this.getErrText('warning'), this.getErrText('on_del'));
            } finally {
                this.isLoad = false;
            }
        }, // удаление сохраненных данных строки/строк вместе с прикрепленными файлами

        getFiles(data) {
            this.files = data;
        },

        async onFilesClick(item) {
            if (item.id < 0 && (!item.row_files || !item.row_files.length)) {
                try {
                    const response = await fetch(`/api-py/get-new-row-files-form/${item.id}/` + JSON.stringify(this.header));
                    const otherFiles = await response.json();
                    this.$set(item, 'row_files', otherFiles);
                } catch (error) {
                    this.makeToast('danger', `${this.getErrText('bad_request')} onFilesClick()`, error.toString());
                }
            }
            this.$refs.modalFilesManagement.showModal(item);
            this.rowId = item.id;
        },

        async loadDictElectionExpense() {
            try {
                const response = await fetch(`/api-py/get_dict_election_expense/${this.header.variant_date_time}/`);
                this.dictElectionExpense = await response.json();
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDictElectionExpense()`, error.toString());
            }
        },

        fillWithDictAndDefaultData(newBudgetForm) {
            const that = this;
            const actualDictRows = this.dictElectionExpense
                .filter(row => row.is_actual === true)
                .sort((a, b) => a.order_num - b.order_num);

            actualDictRows.forEach(row => {
                const item = {
                    id: this.newRowStartId,
                    expense_code: row.code,
                    expense_amount: 0,
                    candidate_count: 0,
                    files: 0,
                    row_files: [],
                    itemToDelete: false
                };
                this.newRowStartId--;

                Object.defineProperty(item, 'name', {
                    get() {
                        const nameKey = `name_${that.lng}`;
                        return row[nameKey] || row.name_ru;
                    }
                });

                that.defineTotal(item);

                newBudgetForm.push(item);
            });
        }, // построение строк формы из актуальных элементов справочника dict_election_expense

        addToNewBudgetFormDataFromValues(newBudgetForm, values) {
            values.forEach(val => {
                const itemExist = newBudgetForm.find(item => item.expense_code === val.expense_code);
                if (itemExist) {
                    itemExist.id = val.id;
                    itemExist.expense_amount = val.expense_amount;
                    itemExist.candidate_count = val.candidate_count;
                    itemExist.files = val.files;
                    itemExist.row_files = val.row_files;
                }
            });
        }, // подмешивает уже сохраненные данные к построенным из справочника строкам

        async loadSpecificData() {
            await this.loadDictElectionExpense();
        },

        async loadDatas() {
            this.load = true;

            let values = [];
            try {
                const response = await fetch('/api-py/get-budget-request-form-with-row-attach-files/' + JSON.stringify(this.header));
                values = await response.json();
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDatas`, error.toString());
            }

            const newBudgetForm = [];
            this.fillWithDictAndDefaultData(newBudgetForm);
            this.addToNewBudgetFormDataFromValues(newBudgetForm, values);

            this.budgetForm.splice(0);
            this.budgetForm = newBudgetForm;

            this.load = false;
            this.$nextTick(() => { this.isDirty = false; });
        },

        isRowValid(row, rowNumber) {
            const hasAmount = parseFloat(row.expense_amount) > 0;
            const hasCount = parseInt(row.candidate_count) > 0;
            if (!hasAmount && !hasCount) return true; // полностью пустая строка не блокирует сохранение

            let valid = true;
            const prefix = `${this.getErrText('row')} ${rowNumber}. `;
            if (!hasAmount) {
                this.makeToast('warning', this.getErrText('msg'), prefix + this.getErrText('cant_be_zero', { fieldName: this.getFormText('expense_amount') }));
                valid = false;
            }
            if (!hasCount) {
                this.makeToast('warning', this.getErrText('msg'), prefix + this.getErrText('cant_be_zero', { fieldName: this.getFormText('candidate_count') }));
                valid = false;
            }
            return valid;
        },

        prepareForSave() {
            let hasError = false;
            let rowNumber = 1;
            for (const row of this.budgetForm) {
                if (!this.isRowValid(row, rowNumber)) hasError = true;
                rowNumber++;
            }
            if (hasError) return;

            const isFilled = row => (parseFloat(row.expense_amount) > 0) || (parseInt(row.candidate_count) > 0);
            const filledRows = this.budgetForm.filter(isFilled);
            const clearedSavedRows = this.budgetForm.filter(row => row.id > 0 && !isFilled(row));

            const values = filledRows.map(row => {
                const item = Object.assign({}, this.header);
                this.$set(item, 'id', row.id);
                this.$set(item, 'expense_code', row.expense_code);
                this.$set(item, 'expense_amount', row.expense_amount);
                this.$set(item, 'candidate_count', row.candidate_count);
                this.$set(item, 'row_files', row.row_files);
                return item;
            });

            let onConfirm;
            if (values.length === 0 && clearedSavedRows.length === 0) {
                this.makeToast('warning', this.getErrText('msg'), this.getErrText('not_saved'));
                return;
            } else if (values.length === 0) {
                onConfirm = () => this.deleteExpenseRows(clearedSavedRows, clearedSavedRows.map(row => row.id));
            } else if (clearedSavedRows.length === 0) {
                onConfirm = () => this.save(values);
            } else {
                onConfirm = async () => {
                    await this.deleteExpenseRows(clearedSavedRows, clearedSavedRows.map(row => row.id));
                    await this.save(values);
                };
            }

            this.$bvModal.msgBoxConfirm(
                this.getCommonText('on_save'),
                {
                    title: this.getCommonText('confirm'),
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: this.getCommonText('yes'),
                    cancelTitle: this.getCommonText('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value && this.variantAttribute) {
                        onConfirm();
                    }
                })
                .catch(error => {
                    this.makeToast('danger', this.getErrText('saving_error'), error.toString());
                });
        },

        async save(values) {
            this.isLoad = true;
            try {
                const data = {
                    values,
                    header: this.header,
                };
                const response = await fetch('/api-py/save-brform02-166', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(data)
                });
                const result = await response.json();
                if ((response.status === 200) && (result.result === 'success')) {
                    if (this.files.length === 0) {
                        this.makeToast('warning', this.getErrText('warning'), this.getErrText('no_docs'));
                    }
                    this.selectAll = false;
                    this.makeToast('success', this.getErrText('msg'), this.getErrText('saved'));
                    this.deletingAgreementTotalResultHandler(result);
                    await this.loadDatas();
                } else {
                    this.selectAll = false;
                    await this.loadDatas();
                    throw this.getErrText('bad_data');
                }
            } catch (e) {
                this.makeToast('danger', this.getErrText('warning'), e.toString());
            } finally {
                this.isLoad = false;
            }
        },
    },
    computed: {
        total() {
            return this.totalCalculation(this.budgetForm, 'total');
        },

        getFormText() {
            return this.setFormText('form_02_166.');
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: 'action',
                        label: ' '
                    },
                    {
                        key: 'order_number',
                        label: '№'
                    },
                    {
                        key: 'expense_name',
                        label: this.getFormText('expense_name'),
                        thStyle: 'width: 50%'
                    },
                    {
                        key: 'expense_amount',
                        label: this.getFormText('expense_amount')
                    },
                    {
                        key: 'candidate_count',
                        label: this.getFormText('candidate_count')
                    },
                    {
                        key: 'total_expense',
                        label: this.getFormText('total_expense'),
                        thStyle: 'max-width: 240px'
                    },
                    {
                        key: 'files',
                        label: this.getCommonText('files')
                    },
                    {
                        key: 'more',
                        label: ''
                    }
                ];
            };
            return [];
        },

    }
};
</script>
<style scoped>
    .filter-actions-flex {
        display: flex;
    }
    .goods-form-val-msg {
        font-size: 0.5rem;
        font-style: italic;
        color: red;
    }
</style>
